import React, {useEffect} from 'react';
import {FieldSelectorConfig} from "../../convert-fields-structure";
import FieldProto from "../../../../../fields3/proto/field-proto";
import FieldItem from "../fields-list/option-item/field-item";

type Props = {
    searchValue         : string
    config?             : FieldSelectorConfig
    selectedFieldIds    : ID[]
    columns?            : any[]

    onSelect            : callback
}

type State = {
    systemFields: FieldProto[],
    customFields: FieldProto[]
}

export default function FieldSelector_SearchResults(props: Props) {

    const [searchResult, setSearchResult] = React.useState<State>({systemFields: [], customFields: []})

    const systemField = _.filter(props.config?.allFields, (field: FieldProto)=>!field.isCustom);
    const customField = _.filter(props.config?.allFields, (field: FieldProto)=>field.isCustom);

    const searchFields = ()=> {
        setSearchResult({
            systemFields: systemField.filter((field: FieldProto)=>field.label.toLowerCase().includes(props.searchValue.toLowerCase())),
            customFields: customField.filter((field: FieldProto)=>field.label.toLowerCase().includes(props.searchValue.toLowerCase())),
        })
    }

    useEffect(()=>{
        searchFields()
    }, [props.searchValue])

    return (
        <>
            {searchResult.systemFields?.length > 0 && (
                <div className="ui5-header">
                    <div className="name">System fields</div>
                </div>
            )}

            {_.map(searchResult?.systemFields, (field: FieldProto) => {

                const selectedColumn = _.find(props.columns, column=>column.fieldId === field.fieldId)
                const isSelected = _.intersection(props.selectedFieldIds, [field.fieldId, field.systemFieldId]).length > 0 //props.selectedFieldIds?.includes(field.fieldId)

                return <FieldItem key                   = {field.fieldId}
                                  field                 = {field}
                                  params                = {selectedColumn?.params}
                                  disabled              = {false}
                                  selected              = {!!selectedColumn || isSelected}
                                  hasIcons              = {true}
                                  // showModifierOptions   = {props.showModifierOptions}
                                  onClick               = {props.onSelect}/>
            })}

            {searchResult.customFields?.length > 0 && (
                <div className="ui5-header m-t-10">
                    <div className="name">Custom fields</div>
                </div>
            )}

            {
                _.map(searchResult?.customFields, (field: FieldProto) => {
                    const selectedColumn = _.find(props.columns, column=>column.fieldId === field.fieldId)
                    const isSelected = props.selectedFieldIds?.includes(field.fieldId)

                    return <FieldItem key                   = {field.fieldId}
                                      field                 = {field}
                                      params                = {selectedColumn?.params}
                                      disabled              = {false}
                                      selected              = {!!selectedColumn || isSelected}
                                      hasIcons              = {true}
                                      // showModifierOptions   = {props.showModifierOptions}
                                      onClick               = {props.onSelect}/>
                })
            }

            {searchResult.systemFields?.length === 0 &&
                searchResult.customFields?.length ===0 && (
                    <div className="flex-row-center-center h-100-percent w-100-percent">
                        <div className="ui5-txt-not-important">
                            No results
                        </div>
                    </div>
                )}
        </>
    );
}
